import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

const Content = ({reportData, data, entity, title, collapsed, printComponentRef, setLoading, showMap, mapImage, mapMode, setMapMode, setMapLoaded}) => {
    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

                        <div className={"w-full mt-[25px] print:mt-[0]"}>
                            <ReportContent
                                data={reportData}
                                collapsed={collapsed}
                                showMap={showMap}
                                mapImage={mapImage}
                                mapMode={mapMode}
                                setMapMode={setMapMode}
                                setMapLoaded={setMapLoaded}
                            />
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;